"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPersistedData = exports.clearPersistedData = exports.getPersistedData = exports.STORAGE_KEY = void 0;
exports.STORAGE_KEY = '@qubic-js';
function getPersistedData() {
    try {
        const result = localStorage.getItem(`${exports.STORAGE_KEY}/accounts`);
        if (!result)
            return null;
        const accounts = JSON.parse(result || '[]');
        if (accounts.length === 0)
            return null;
        const chainId = localStorage.getItem(`${exports.STORAGE_KEY}/chainId`);
        if (!chainId)
            return null;
        return {
            accounts,
            chainId,
        };
    }
    catch (error) {
        // silent failed
        return null;
    }
}
exports.getPersistedData = getPersistedData;
function clearPersistedData() {
    localStorage.removeItem(`${exports.STORAGE_KEY}/accounts`);
    localStorage.removeItem(`${exports.STORAGE_KEY}/chainId`);
}
exports.clearPersistedData = clearPersistedData;
function setPersistedData(key, stringifiedValue) {
    localStorage.setItem(`${exports.STORAGE_KEY}/${key}`, stringifiedValue);
}
exports.setPersistedData = setPersistedData;
